import React from "react";
import { Box, Typography } from "@mui/material";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import { ChartTooltip } from "./chartTheme";

const CreatedActivatedChart = ({ created = 0, activated = 0 }) => {
  if (created === 0) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
        <Typography sx={{ fontSize: 12.5, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150, 10%, 46%)" }}>
          No candidates created in this period.
        </Typography>
      </Box>
    );
  }

  const notYet = Math.max(created - activated, 0);
  const pct = Math.round((activated / created) * 100);
  const slices = [
    { name: "Activated", value: activated, color: "hsl(142, 71%, 45%)" },
    { name: "Not yet", value: notYet, color: "hsl(140, 8%, 82%)" },
  ];

  return (
    <Box sx={{ position: "relative", height: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={slices} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius="64%" outerRadius="84%" startAngle={90} endAngle={-270} stroke="none">
            {slices.map((s) => (
              <Cell key={s.name} fill={s.color} />
            ))}
          </Pie>
          <Tooltip content={<ChartTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", pointerEvents: "none" }}>
        <Typography sx={{ fontSize: 28, fontFamily: "Segoe UI Bold, sans-serif, system-ui", color: "hsl(150, 30%, 12%)", lineHeight: 1 }}>
          {pct}%
        </Typography>
        <Typography sx={{ fontSize: 11, fontFamily: "Segoe UI Regular, sans-serif, system-ui", color: "hsl(150, 10%, 46%)", mt: "2px" }}>
          {activated}/{created} activated
        </Typography>
      </Box>
    </Box>
  );
};

export default CreatedActivatedChart;
